export default function(x) {
  return function() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-contour/src/constant.js
// module id = 1gxa
// module chunks = 0